export const differenceInMonths = (dateLeft: Date, dateRight: Date) => {
  const diffInMs = dateLeft.getTime() - dateRight.getTime();

  const msInMonth = 1000 * 60 * 60 * 24 * 30.4375;

  const diffInMonths = +(diffInMs / msInMonth).toFixed(2);

  return diffInMonths < 0 ? 0 : diffInMonths;
};
